import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/campagne/Campagne.vue'),
		meta: {
			title: 'campagne',
			acl: 'section.campagne'
		}
	},
	{
		path: 'new',
		component: () => import('@/views/campagne/campagna/CampagnaDetail.vue'),
		meta: {
			title: 'new-campagna',
			acl: 'section.campagne'
		}
	},
	{
		path: ':campagnaid/edit',
		component: () => import('@/views/campagne/campagna/CampagnaDetail.vue'),
		props: true,
		meta: {
			title: 'edit-campagna',
			acl: 'section.campagne'
		}
	},
];

export default routes;